import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const HorizontalMenuIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M10.0001 2C10.0001 0.89543 9.10463 -1.35705e-07 8.00006 -8.74228e-08C6.89549 -3.91405e-08 6.00006 0.895431 6.00006 2C6.00006 3.10457 6.89549 4 8.00006 4C9.10463 4 10.0001 3.10457 10.0001 2Z"
    />
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M16.0001 2C16.0001 0.89543 15.1046 -1.35705e-07 14.0001 -8.74228e-08C12.8955 -3.91405e-08 12.0001 0.895431 12.0001 2C12.0001 3.10457 12.8955 4 14.0001 4C15.1046 4 16.0001 3.10457 16.0001 2Z"
    />
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M4 2C4 0.89543 3.10457 -1.35705e-07 2 -8.74228e-08C0.89543 -3.91405e-08 -1.35705e-07 0.895431 -8.74228e-08 2C-3.91405e-08 3.10457 0.89543 4 2 4C3.10457 4 4 3.10457 4 2Z"
    />
  </svg>
);

HorizontalMenuIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

HorizontalMenuIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(16, 4),
};

export default HorizontalMenuIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/horizontal-menu.js